import { i18n } from '@/i18n';
import { DialogListConfig, ModuleListConfig, ModuleName } from '@/types/module-type';
import Recommend from '@/components/area/mainland/recommend/index.vue';
import NewUserZone from '@/components/area/mainland/new-user-zone/index.vue';
import Banner from '@/components/area/mainland/merchant-banner/index.vue';
import WeCouponMall from '@/components/area/mainland/we-coupon-mall.vue';
import HotMerchant from '@/components/area/mainland/hot-merchant.vue';
import CityStrategy from '@/components/area/mainland/city-strategy.vue';
import AreaREcommend from '@/components/area-recommend.vue';
import CouponGuide from '@/components/area/mainland/coupon-guide.vue';
import AdDialog from '@/components/area/mainland/ad-dialog/index.vue';

/** 跨境游-中国内地-优惠banner */
export const MAINLAND_COMMON_BANNER_POSID = '1100040000370001';
/** 跨境游-中国内地-热门优惠banner */
export const MAINLAND_MERCHANT_BANNER_POSID = '1100040000370013';

/** 跨境游-中国内地-热门优惠- column1左侧大图 */
export const MAINLAND_MERCHANT_RECOMMEND_POSID_LEFT = '1100040000370014';
/** 跨境游-中国内地-热门优惠- column1右上小图 */
export const MAINLAND_MERCHANT_RECOMMEND_POSID_RIGHT_TOP = '1100040000370016';
/** 跨境游-中国内地-热门优惠- column1右下小图 */
export const MAINLAND_MERCHANT_RECOMMEND_POSID_RIGHT_DOWN = '1100040000370015';
/** 跨境游-中国内地-热门优惠推荐位布局列表 */
export const MAINLAND_MERCHANT_RECOMMEND_POSID_LIST = [MAINLAND_MERCHANT_RECOMMEND_POSID_LEFT,
  MAINLAND_MERCHANT_RECOMMEND_POSID_RIGHT_TOP, MAINLAND_MERCHANT_RECOMMEND_POSID_RIGHT_DOWN];

/** 跨境游-中国内地-迎新券 */
export const MAINLAND_COUPON_GUIDE_POSID = '1100040000370017';

// 中国内地模块配置
export const MAINLAND_MODULE_CONF: ModuleListConfig = [
  {
    moduleName: ModuleName.Recommend,
    component: Recommend,
    sort: 1,
  },
  {
    moduleName: ModuleName.NewUserZone,
    component: NewUserZone,
    sort: 2,
  },
  {
    moduleName: ModuleName.MerchantBanner,
    component: Banner,
    sort: 3,
    moduleTitle: i18n('北上精选'),
    extraConfig: {
      modulePositionId: [
        MAINLAND_COMMON_BANNER_POSID,
        ...MAINLAND_MERCHANT_RECOMMEND_POSID_LIST,
      ],
    },
  },
  {
    moduleName: ModuleName.CouponGuide,
    component: CouponGuide,
    sort: 4,
  },
  {
    moduleName: ModuleName.WeCouponMall,
    component: WeCouponMall,
    sort: 5,
  },
  {
    moduleName: ModuleName.HotMerchant,
    component: HotMerchant,
    sort: 6,
  },
  {
    moduleName: ModuleName.CityStrategy,
    component: CityStrategy,
    sort: 7,
    moduleTitle: i18n('資訊專區'),
  },
  {
    moduleName: ModuleName.AreaREcommend,
    component: AreaREcommend,
    sort: 8,
    moduleTitle: i18n('探尋更多目的地'),
  },
];

// 中国内地弹窗配置
export const MAINLAND_DIALOG_CONF: DialogListConfig = [AdDialog];
